import {
  ACCOUNT_FIELDS,
  ADDRESS_FIELDS,
  APPLICATION_FIELDS,
  CONTACT_FIELDS
} from './serverFieldMappings';

export default {
  CONTACT: {
    fields: Object.values(CONTACT_FIELDS)
  },
  CONTACT_ADDRESS: {
    fields: Object.values(ADDRESS_FIELDS)
  },
  ACCOUNT: {
    fields: Object.values(ACCOUNT_FIELDS)
  },
  ACCOUNT_ADDRESS: {
    fields: Object.values(ADDRESS_FIELDS)
  },
  APPLICATION: {
    fields: Object.values(APPLICATION_FIELDS)
  },
};
